module.exports = __webpack_public_path__ + "img/needs_selected.9614d64b.svg";